import { Form, Col } from "react-bootstrap";
import { isAlphanumericAllSpecialCharacters } from "../../../../functions/validations";
import { Tooltip_detail } from "../../common/helpers/Tooltip";
import Img from "../../../../icons/ErrorIcon.svg";

export const SingleInputTextArea = ({
  status,
  type,
  name,
  value,
  handleChange,
  typeclass,
  style,
  readOnly,
  label,
  message,
  onInput,
  maxLength,
  disabled
}) => {
  return (
    <>
      <div className="T-input w-100">
        <textarea
          type={type}
          typeclass={typeclass}
          name={name}
          style={style}
          id={name}
          disabled={disabled}
          readOnly={readOnly}
          maxLength={maxLength}
          placeholder=" "
          className={
            status
              ? " T-input placeHolderInput inputText text-field-with-error"
              : "T-input placeHolderInput inputText"
          }
          value={value}
          onChange={handleChange}
          onInput={onInput}
        />
        <Form.Label htmlFor={name}>{label}</Form.Label>
      </div>
      <div className="required-text1">
        {status && <Form.Text className="text-danger">{message}</Form.Text>}
      </div>
    </>
  );
};

export const SingleInput = ({
  status,
  name,
  value,
  onChange,
  style,
  label,
  message,
  maxLength,
  disabled,
  width,
  setError,
  md,
  allowlistfunction,
  allowcharacters,
  customMessage
}) => {

  return (
    <>
      <Col md={md} style={style}>
        <Form.Group style={{ width }}>
          <div className="T-input w-100">
            <input
              type="text"
              id={name}
              name={name}
              placeholder=" "
              disabled={disabled}
              maxLength={maxLength}
              className={status ? "err-input" : ""}
              value={value}
              onChange={onChange}
              onInput={(e) => {
                let error1 = allowlistfunction ? allowlistfunction(e.target.value, allowcharacters, customMessage) : isAlphanumericAllSpecialCharacters(e.target.value);
                setError((prevState) => ({
                  ...prevState,
                  [name]: error1,
                }));
              }}
            />
            <Form.Label htmlFor={name}>{label}</Form.Label>
          </div>
          <div className="required-text">
            {status && (
              <Form.Text className="text-danger">
                {message}
              </Form.Text>
            )}
          </div>
        </Form.Group>
      </Col>
    </>
  );
};


// export const SingleInputTextAreaNotesWPS = ({
//   status,
//   type,
//   name,
//   value,
//   handleChange,
//   typeclass,
//   style,
//   readOnly,
//   label,
//   message,
//   maxLength,
//   disabled
// }) => {
//   const handleInput = (e) => {
//     let inputValue = e.target.value;

//     // Capitalize first letter of entire text
//     if (inputValue.length > 0) {
//       inputValue = inputValue.charAt(0).toUpperCase() + inputValue.slice(1);
//     }

//     // Capitalize first letter after every newline
//     inputValue = inputValue.replace(/(\n)([a-z])/g, (match, newline, char) => newline + char.toUpperCase());

//     // Insert newline after every 120 characters in a line
//     const lines = inputValue.split("\n").map(line => {
//       if (line.length > 120) {
//         return line.match(/.{1,120}/g).join("\n");
//       }
//       return line;
//     });

//     const finalValue = lines.join("\n");

//     e.target.value = finalValue;

//     if (handleChange) {
//       handleChange(e);
//     }
//   };

//   const textareaProps = {
//     type,
//     typeclass,
//     name,
//     style,
//     id: name,
//     disabled,
//     readOnly,
//     maxLength,
//     placeholder: " ",
//     value,
//     onChange: handleChange,
//     onInput: handleInput
//   };

//   return (
//     <>
//       <div style={{ width: "100%", marginBottom: "8px" }}>
//         <textarea
//           {...textareaProps}
//           style={{
//             width: "100%",
//             minHeight: "120px",
//             padding: "10px",
//             fontSize: "14px",
//             border: status ? "1px solid red" : "1px solid #ccc",
//             borderRadius: "4px",
//             resize: "vertical",
//             whiteSpace: "pre-wrap",
//             wordWrap: "break-word",
//             outline: "none"
//           }}
//           className={
//             status
//               ? "T-input placeHolderInput inputText text-field-with-error"
//               : "T-input placeHolderInput inputText"
//           }
//         />
//         <Form.Label htmlFor={name} style={{ display: "block", marginTop: "4px", fontWeight: "bold" }}>
//           {label}
//         </Form.Label>
//       </div>
//       <div style={{ color: "red", fontSize: "12px" }}>
//         {status && <Form.Text className="text-danger">{message}</Form.Text>}
//       </div>
//     </>
//   );
// };



export const SingleInputTextAreaNotesWPS = ({
  status,
  type,
  name,
  value,
  handleChange,
  typeclass,
  style,
  readOnly,
  label,
  message,
  maxLength, // you can still pass this if you want a global cap too
  disabled
}) => {
  const handleInput = (e) => {
    let inputValue = e.target.value;

    // Remove capitalization logic entirely

    // Insert newline after every 120 characters in a line
    const lines = inputValue.split("\n").map(line => {
      if (line.length > 120) {
        return line.match(/.{1,120}/g).join("\n");
      }
      return line;
    });

    const finalValue = lines.join("\n");

    // Mutate the event target for compatibility with existing handleChange
    e.target.value = finalValue;

    if (handleChange) {
      handleChange(e);
    }
  };

  const textareaProps = {
    type,
    typeclass,
    name,
    style,
    id: name,
    disabled,
    readOnly,
    // keep maxLength if you want to additionally cap overall text
    maxLength,
    placeholder: " ",
    value,
    onChange: handleChange,
    onInput: handleInput
  };

  return (
    <>
      <div style={{ width: "100%", marginBottom: "8px" }}>
        <textarea
          {...textareaProps}
          style={{
            width: "100%",
            minHeight: "120px",
            padding: "10px",
            fontSize: "14px",
            border: status ? "1px solid red" : "1px solid #ccc",
            borderRadius: "4px",
            resize: "vertical",
            whiteSpace: "pre-wrap",
            wordWrap: "break-word",
            outline: "none"
          }}
          className={
            status
              ? "T-input placeHolderInput inputText text-field-with-error"
              : "T-input placeHolderInput inputText"
          }
        />
        <Form.Label htmlFor={name} style={{ display: "block", marginTop: "4px", fontWeight: "bold" }}>
          {label}
        </Form.Label>
      </div>
      <div style={{ color: "red", fontSize: "12px" }}>
        {status && <Form.Text className="text-danger">{message}</Form.Text>}
      </div>
    </>
  );
};

export const SingleInputTextAreaNotes = ({
  status,
  type,
  name,
  value,
  handleChange,
  typeclass,
  style,
  readOnly,
  label,
  message,
  onInput,
  maxLength,
  disabled
}) => {
  const textareaProps = {
    type,
    typeclass,
    name,
    style,
    id: name,
    disabled,
    readOnly,
    maxLength,
    placeholder: " ",
    value,
    onChange: handleChange,
    onInput
  };

  return (
    <>
      <div className="T-input w-100">
        <textarea
          {...textareaProps}
          className={
            status
              ? " T-input placeHolderInput inputText text-field-with-error"
              : "T-input placeHolderInput inputText"
          }
        />
        <Form.Label htmlFor={name}>{label}</Form.Label>
      </div>
      <div className="required-text1">
        {status && <Form.Text className="text-danger">{message}</Form.Text>}
      </div>
    </>
  );
};

export const ToolError = ({ title }) => {
  return (
    <Tooltip_detail
      content="All Fields are Mandatory"
      id="tooltip-tab1"
      className="front"
    >
      <img src={Img} alt="Error" className="ms-1 front" />
      {title}
    </Tooltip_detail>
  );
};

export const General_Single_Input_select = ({
  status,
  name,
  value,
  handleSelectChange,
  readOnly,
  label,
  message,
  array,
  disabled
}) => {
  return (
    <>
      <div className="T-input w-100">
        <select
          id={name}
          name={name}
          readOnly={readOnly}
          isDisabled={disabled}
          disabled={disabled}
          placeholder=" "
          value={value}
          className={status ? "err-input" : ""}
          onChange={handleSelectChange}
        >
          {array &&
            array.map((e, id) => {
              return (
                <option key={e.value || `option-${id}`} value={e.value}>
                  {e.name}
                </option>
              );
            })}
        </select>
        <Form.Label htmlFor={name}>{label}</Form.Label>
      </div>
      <div className="required-text">
        {status && <Form.Text className="text-danger">{message}</Form.Text>}
      </div>
    </>
  );
};

export const General_Single_Input_select_green = ({
  status,
  name,
  value,
  handleSelectChange,
  readOnly,
  disabled,
  label,
  message,
  array,
}) => {
  return (
    <>
      <div className="green-input w-100">
        <select
          id={name}
          name={name}
          readOnly={readOnly}
          disabled={disabled}
          isDisabled={disabled}
          placeholder=" "
          value={value}
          className={status ? "err-input" : ""}
          onChange={handleSelectChange}
        >

          {array &&
            array.map((e, id) => {
              return (
                <option key={e.value || `green-option-${id}`} value={e.value}>
                  {e.name}
                </option>
              );
            })}
        </select>
        <Form.Label htmlFor={name}>{label}</Form.Label>
      </div>
      <div className="required-text">
        {status && <Form.Text className="text-danger">{message}</Form.Text>}
      </div>
    </>
  );
};

export const Single_Input_Superviser_remark = ({
  status,
  type,
  name,
  value,
  handleChange,
  typeclass,
  style,
  readOnly,
  label,
  message,
  onInput,
  maxLength,
  disabled,
}) => {
  return (
    <>
      <div className="T-input w-100">
        <input
          type={type}
          typeclass={typeclass}
          name={name}
          style={style}
          id={name}
          disabled={disabled}
          readOnly={readOnly}
          maxLength={maxLength}
          placeholder=" "
          className={
            status
              ? "T-input placeHolderInput inputText text-field-with-error"
              : "T-input placeHolderInput inputText"
          }
          value={value}
          onChange={handleChange}
          onInput={onInput}
        />
        <Form.Label htmlFor={name}>{label}</Form.Label>
      </div>
      <div className="required-text1">
        {status && <Form.Text className="text-danger">{message}</Form.Text>}
      </div>
    </>
  );
};